import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'project',
    loadChildren: () => import('./project/project.module').then((mod) => mod.ProjectModule),
  },
  {
    path: 'safety',
    loadChildren: () => import('./safety/safety.module').then((m) => m.SafetyModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ObjectRoutingModule {}
